/* eslint-disable no-unused-vars */
import axios from "../../axios";

const urlFreezing = "/master/freezings";
const urlFreezingActive = "/master/freezings/active";
const urlFreezingDeleteMultiple = "/master/freezings/delete-multiple";
const urlStudent = "/user/students";
const state = {
  freezings: [],
  pagination: {
    current_page: 1,
    per_page: 10,
    total: 0,
  },
};

const actions = {
  /**
   * Get list freezings
   * @param commit
   * @param query
   * @returns {Promise<void>}
   */
  async getListFreezings({ commit }, query) {
    try {
      const response = await axios.get(
        `${urlFreezing}?${new URLSearchParams(query)}`,
      );
      if (response.status === 200) {
        commit("SET_LIST_FREEZINGS", response.data.data);
      }
    } catch (e) {
      console.log("exception: ", e);
    }
  },

  /**
   * Get list student update freezings
   * @param commit
   * @param query
   * @returns {Promise<void>}
   */
  async getStudentUpdateLists({ commit }, query) {
    try {
      const response = await axios.get(
        `${urlStudent}?${new URLSearchParams(query)}`,
      );
      if (response.status === 200) {
        return response.data.data.items;
      }
    } catch (e) {
      console.log("exception: ", e);
    }
  },

  /**
   * Create freezing
   * @param commit
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  async create({ commit }, payload) {
    return await axios.post(urlFreezing, payload, {
      headers: { "Content-Type": "application/json" },
    });
  },

  /**
   * Update freezing
   * @param commit
   * @param id
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  async update({ commit }, { id, payload }) {
    return await axios.put(`${urlFreezing}/${id}`, payload, {
      headers: { "Content-Type": "application/json" },
    });
  },

  /**
   * Active freezing
   * @param commit
   * @param id
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  async active({ commit }, id) {
    return await axios
      .post(`${urlFreezingActive}/${id}`, {
        headers: { "Content-Type": "application/json" },
      })
      .then((response) => {
        commit("UPDATE_ITEM", response.data.data);
      });
  },

  /**
   * Delete freezing
   * @param commit
   * @param id
   * @returns {Promise<AxiosResponse<any>>}
   */
  async delete({ commit }, id) {
    return await axios.delete(`${urlFreezing}/${id}`);
  },

  /**
   * delete multiple freezing
   * @param commit
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  async deleteMultiple({ commit }, payload) {
    return await axios.post(urlFreezingDeleteMultiple, payload);
  },

  /**
   * set current page
   * @param commit
   * @param data
   */
  setCurrentPage({ commit }, data) {
    commit("SET_CURRENT_PAGE", data);
  },

  /**
   * set per page
   * @param commit
   * @param data
   */
  setPerPage({ commit }, data) {
    commit("SET_PER_PAGE", data);
  },
};

const mutations = {
  SET_LIST_FREEZINGS(state, data) {
    state.freezings = data.items;
    state.pagination = data.pagination;
  },
  ADD_ITEM(state, item) {
    state.freezings.push(item);
  },
  UPDATE_ITEM(state, item) {
    const index = state.freezings.findIndex((u) => u.id === item.id);
    if (index >= 0) {
      state.freezings.splice(index, 1, item);
    }
  },
  SET_CURRENT_PAGE(state, data) {
    console.log(data, "SET_CURRENT_PAGE");
    state.pagination.current_page = data;
  },
  SET_PER_PAGE(state, data) {
    state.pagination.per_page = data;
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
